import React, { useRef, useState, useEffect } from 'react';
import api from 'constants/api';
import convertUnixTimeToDate from 'functions/convertUnixTimeToDate.func';
import { fC } from 'helpers/locale';
import AxiosPageReadyWrapper from '../AxiosPageReadyWrapper';
import { getLoyaltyProgramQuery } from './query';
import TierCircle from './TierCircle';
import { getTierLabel, getNextTierStatus, getNextTierLabel } from './tiers';

const LoyaltyProgram = ({ onLoaded }) => {
  const pageReady = useRef();
  const [loyaltyProgram, setLoyaltyProgram] = useState([]);
  const [animateProgress, setAnimateProgress] = useState(false);

  const getLoyaltyProgram = (data) => {
    const {
      data: {
        data: { loyalty_program },
      },
    } = data;
    setLoyaltyProgram(loyalty_program);

    if (onLoaded) {
      onLoaded(loyalty_program);
    }
  };

  useEffect(() => {
    if (
      loyaltyProgram &&
      (loyaltyProgram?.items?.current > 0 || loyaltyProgram?.spend?.current > 0)
    ) {
      setTimeout(() => setAnimateProgress(true), 50);
    }
  }, [loyaltyProgram]);

  const currentStatus = loyaltyProgram?.loyalty_status;
  const nextStatus = getNextTierStatus(loyaltyProgram?.next_status);

  const getBarWidth = (progress) => {
    if (!animateProgress || !progress?.target) {
      return '0%';
    }

    return `${Math.min((progress.current / progress.target) * 100, 100)}%`;
  };

  const getItemsLabel = () => {
    const items = loyaltyProgram?.items;

    if (!items) {
      return '';
    }

    if (items.current >= items.target) {
      return `${items.current} Items`;
    }

    return `${items.current}/${items.target} Items`;
  };

  const getSpentLabel = () => {
    const spend = loyaltyProgram?.spend;

    if (!spend) {
      return '';
    }

    if (spend.current >= spend.target) {
      return `${fC(spend.current)} Spent`;
    }

    return `${fC(spend.current)}/${fC(spend.target)} Spent`;
  };

  const getProgressTitle = () => {
    if (!currentStatus) {
      return '';
    }

    return `${getTierLabel(currentStatus)} until ${convertUnixTimeToDate(
      loyaltyProgram.end_date,
    )}`;
  };

  return (
    <div
      className={`loyalty-program${
        currentStatus ? ` loyalty-program__${currentStatus}` : ''
      }`}>
      <div className="loyalty-program__header">
        <div className="loyalty-program__title">
          {`${getTierLabel(nextStatus)} Progress`}
        </div>
      </div>
      <div
        className="loyalty-program__progress-wrapper"
        title={getProgressTitle()}>
        <AxiosPageReadyWrapper
          ref={pageReady}
          method="post"
          url={api.graphql()}
          postBody={{
            query: getLoyaltyProgramQuery(),
          }}
          onData={getLoyaltyProgram}>
          <div className="loyalty-program__progress">
            <TierCircle
              status={currentStatus}
              label={getTierLabel(currentStatus)}
            />

            <div className="loyalty-program__sales-wrapper">
              <div className="loyalty-program__sales-count">
                <div
                  className="loyalty-program__progress-bar"
                  style={{
                    width: getBarWidth(loyaltyProgram?.items),
                  }}
                />
                <span>{getItemsLabel()}</span>
              </div>

              <div className="loyalty-program__sales-value">
                <div
                  className="loyalty-program__progress-bar"
                  style={{
                    width: getBarWidth(loyaltyProgram?.spend),
                  }}
                />
                <span>{getSpentLabel()}</span>
              </div>
            </div>

            <TierCircle
              status={nextStatus}
              label={getNextTierLabel(loyaltyProgram?.next_status)}
            />
          </div>
        </AxiosPageReadyWrapper>
      </div>
    </div>
  );
};

export default LoyaltyProgram;
